module.exports = __webpack_public_path__ + "static/img/scwj.8bb9448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scwj.jpg
// module id = LQ4K
// module chunks = 4